import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Nav } from "./components/landing/Nav";
import { CTAFooter } from "./components/landing/CTAFooter";
import { StatusTicker } from "./components/landing/StatusTicker";
import { ScrollProgressBar } from "./components/landing/ScrollProgressBar";
import { PricingPlansProvider } from "./hooks/usePricingPlans";
import { SiteNotifications } from "./components/SiteNotifications";
import Seo from "./components/Seo";

export default function Layout() {
    const { pathname, hash } = useLocation();
    const isPaymentResult =
        pathname.startsWith("/pricing/payment/success") ||
        pathname.startsWith("/pricing/payment/failure") ||
        pathname.startsWith("/pricing/payment/result");

    useEffect(() => {
        if (hash) {
            const id = hash.replace("#", "");
            const el = document.getElementById(id);
            if (el) {
                el.scrollIntoView({ behavior: "smooth" });
                return;
            }
        }
        window.scrollTo({ top: 0, behavior: "instant" });
    }, [pathname, hash]);

    return (
        <PricingPlansProvider>
            <Seo />
            <div className="min-h-screen bg-obsidian-300 text-white antialiased">
                <ScrollProgressBar />
                <SiteNotifications />
                <StatusTicker />
                <Nav />
                <main>
                    <Outlet />
                </main>
                {!isPaymentResult && <CTAFooter />}
            </div>
        </PricingPlansProvider>
    );
}
